// AnotherKind — Add to cart without redirecting to /cart page
(function() {
  'use strict';

  function debug(...args) {
    console.log('[AK stay-on-page]', ...args);
  }

  function getCartAddUrl() {
    const base = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
    return base.endsWith('.js') ? base : base + '.js';
  }

  function getCartUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
  }

  function initForm(form) {
    if (form.dataset.akStayInit === 'true') return;
    form.dataset.akStayInit = 'true';

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      debug('Form submit intercepted', form);

      const button = form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]');
      const formData = new FormData(form);

      if (button) {
        button.classList.add('is-loading');
        button.disabled = true;
      }

      fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: formData,
      })
        .then((res) => {
          debug('Add response status:', res.status);
          return res.json();
        })
        .then((response) => {
          debug('Add response body:', response);

          if (response.status && response.status >= 400) {
            showToast(response.description || response.message || 'Error adding to cart', 'error');
            if (button) {
              button.classList.remove('is-loading');
              button.disabled = false;
            }
            return;
          }

          // Success path — toast + cart refresh + button feedback
          showToast(getSuccessMessage(response), 'success');
          refreshCart();
          showAddedState(button);
        })
        .catch((err) => {
          debug('Fetch error:', err);
          showToast('Could not add to cart. Try again.', 'error');
          if (button) {
            button.classList.remove('is-loading');
            button.disabled = false;
          }
        });
    }, true);

    debug('Form initialized', form);
  }

  function showAddedState(button) {
    if (!button) return;

    // Save original HTML so we can restore it
    const originalHTML = button.innerHTML;
    const originalClassList = Array.from(button.classList);

    // Swap to "added" state
    button.classList.remove('is-loading');
    button.disabled = false;
    button.classList.add('ak-is-added');
    button.innerHTML = '<span class="ak-added-label">✓ Added to cart</span>';

    // Restore after 2 seconds
    setTimeout(() => {
      button.classList.remove('ak-is-added');
      button.innerHTML = originalHTML;
    }, 2000);
  }

  function getSuccessMessage(response) {
    const title = response.product_title || response.title || 'Item';
    return `${title} added to cart`;
  }

  function refreshCart() {
    fetch(getCartUrl() + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then((res) => res.json())
      .then((cart) => {
        debug('Cart refreshed, item_count:', cart.item_count);

        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: { cartCount: cart.item_count },
            bubbles: true,
          })
        );

        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          const limit = parseInt(el.getAttribute('data-limit')) || 999;
          let display = cart.item_count;
          if (cart.item_count >= limit) display = '9+';
          el.textContent = display;
          el.setAttribute('data-cart-count', cart.item_count);
        });

        document.querySelectorAll('.cart-link__bubble, .cart-count').forEach((el) => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.classList.add('has-items');
        });
      })
      .catch((err) => debug('Cart refresh error:', err));
  }

  function showToast(message, type = 'success') {
    debug('Showing toast:', message, type);

    const existing = document.querySelector('.ak-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = `ak-toast ak-toast--${type}`;
    toast.innerHTML = `
      <div class="ak-toast__content">
        <span class="ak-toast__icon">${type === 'success' ? '✓' : '!'}</span>
        <span class="ak-toast__message"></span>
      </div>
      <a href="${getCartUrl()}" class="ak-toast__link">View cart</a>
      <button type="button" class="ak-toast__close" aria-label="Close">×</button>
    `;
    toast.querySelector('.ak-toast__message').textContent = message;

    document.body.appendChild(toast);

    void toast.offsetWidth;
    toast.classList.add('ak-toast--visible');

    toast.querySelector('.ak-toast__close').addEventListener('click', () => hideToast(toast));

    setTimeout(() => hideToast(toast), 4000);
  }

  function hideToast(toast) {
    if (!toast) return;
    toast.classList.remove('ak-toast--visible');
    setTimeout(() => {
      if (toast.parentNode) toast.remove();
    }, 300);
  }

  function init() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(init, 500);
  setTimeout(init, 1500);

  window.akStayDebug = function() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    console.log('[AK] Forms found:', forms.length);
    forms.forEach((f, i) => {
      console.log(`[AK] Form ${i}:`, {
        initialized: f.dataset.akStayInit,
        action: f.action,
      });
    });
    console.log('[AK] Cart add URL:', getCartAddUrl());
    console.log('[AK] Cart URL:', getCartUrl());
  };
})();